"use client";

import { useEffect } from "react";
import { WebMidi } from "webmidi";

import { midiEnabled } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { useAudio } from "./AudioPlayer";

export const MidiListener = () => {
  const { state, dispatch } = useSoundboard();
  const { queueSound } = useAudio();

  useEffect(() => {
    if (WebMidi.supported) {
      navigator.permissions.query({ name: "midi" as PermissionName }).then(permission => {
        if (permission.state === "granted") {
          dispatch(midiEnabled());
        }
      });
    }
  }, []);

  // Handle MIDI note messages
  useEffect(() => {
    if (!state.midi.enabled) return;

    // Clear previous listeners when active device changes
    WebMidi.inputs.forEach(input => {
      input.removeListener("noteon");
    });

    // Set up listeners for active device or all devices if none selected
    const inputsToUse = state.midi.activeDeviceId
      ? [WebMidi.getInputById(state.midi.activeDeviceId)].filter(Boolean)
      : WebMidi.inputs;

    inputsToUse.forEach(input => {
      if (!input) return;

      input.addListener("noteon", e => {
        if (state.isInEditMode || !!state.panel) return;

        const note = e.note.number;
        // Only use mapping from state - no defaults
        const mapping = state.midi.mapping || {};
        const buttonIndex = mapping[note];

        if (buttonIndex !== undefined) {
          const sound = state.presets[state.activePresetId!]?.sounds[buttonIndex];
          if (sound && sound.type === "sound") {
            queueSound(sound.id);
          }
        }
      });
    });

    return () => {
      // Clean up listeners
      WebMidi.inputs.forEach(input => {
        input.removeListener("noteon");
      });
    };
  }, [
    state.midi.enabled,
    state.midi.activeDeviceId,
    state.midi.mapping,
    state.isInEditMode,
    state.panel,
    state.presets,
    state.activePresetId,
    queueSound,
  ]);

  // No UI rendering, just the MIDI event handling
  return null;
};
